import React, { Component } from 'react'
import { Modal, Button, message } from 'hljd'
import { getObjValue, addSuffix, removeSuffix } from '@hlj/hlj-utils'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { getImageAutoOrientLink } from '@util'

export default class extends Component {
  clipInfo = {}
  static defaultProps = {
    img: [],
    slideWidth: 530,
    slideHeight: 320,
    keyField: 'url',
    index: 0 //ImgGallery中需要传递这个表明当前截图的是哪一个以便回调使用
  }

  constructor() {
    super()
    this.state = {
      clipConfig: {
        x: 0,
        y: 0,
        width: 100
      }
    }
  }

  // 裁剪框居中
  handleImageLoaded = (data, url, index) => (crop, el, pixelCrop) => {
    if (this.props.clipConfig) {
      return
    }
    const { width, height } = crop
    // x,y 位置百分比
    const x = 50 - width / 2
    const y = 50 - height / 2

    this.setState({
      clipConfig: {
        x: x,
        y: y,
        width: 100
      }
    })
    // 设置裁剪信息
    const pixelX = Math.ceil((x * el.naturalWidth) / 100)
    const pixelY = Math.ceil((y * el.naturalHeight) / 100)
    this.clipInfo = {
      data,
      index,
      url,
      crop,
      clipUrl:
        removeSuffix(url) +
        `?imageMogr2/crop/!${pixelCrop.width}x${
          pixelCrop.height
        }a${pixelX}a${pixelY}`,
      pixel: pixelCrop
    }
  }

  onComplete = (data, url, index) => (crop, pixelCrop) => {
    const { width, height, x, y } = pixelCrop
    this.setState({
      clipConfig: crop
    })
    this.clipInfo = {
      data,
      index,
      url,
      crop,
      clipUrl:
        removeSuffix(url) +
        `?imageMogr2/auto-orient/crop/!${width}x${height}a${x}a${y}`,
      pixel: pixelCrop
    }
  }
  saveClip = () => {
    const { onCliped, onCancel } = this.props
    if (
      JSON.stringify(this.clipInfo) != '{}' &&
      this.clipInfo.crop &&
      this.clipInfo.crop.height &&
      this.clipInfo.crop.width
    ) {
      if (onCliped) {
        onCliped(this.clipInfo)
      }
      if (onCancel) {
        onCancel()
      }
    } else {
      message.warning('还没有截图信息，请截图！')
    }
  }

  /**
   * 裁剪取消则传 cancel 参数，此情况下需重置剪裁框中的 url
   */
  onCancel = () => {
    const { onCancel } = this.props
    onCancel && onCancel('cancel')
  }

  render() {
    const {
      img,
      slideWidth,
      slideHeight,
      keyField,
      aspect,
      visible,
      clipConfig,
      index,
      title
    } = this.props
    const _aspect = typeof aspect === 'function' ? aspect(img, index) : aspect
    const _clipConfig =
      typeof clipConfig === 'function'
        ? clipConfig(img, index)
        : clipConfig || this.state.clipConfig
    let resConfig = { aspect: _aspect, ..._clipConfig }
    let _modalWidth = slideWidth + 200
    let slideStyle = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f5f5f5',
      height: slideHeight
    }
    const url = getObjValue(img, keyField)
    // const _url = addSuffix(url, 'imageView2/2/q/30', true)
    const __url = addSuffix(url, 'imageView2/2/q/30', true)
    const _url = getImageAutoOrientLink(__url)
    return (
      <Modal
        title={title ? title : ''}
        closable={false}
        maskClosable={false}
        width={_modalWidth}
        footer={[
          <Button key="c" onClick={this.onCancel}>
            取消
          </Button>,
          <Button key="s" type="primary" onClick={this.saveClip}>
            保存
          </Button>
        ]}
        visible={visible}
        onCancel={this.onCancel}
      >
        {
          <style
            dangerouslySetInnerHTML={{
              __html: `
                            .ReactCrop>img{
                                max-width:${slideWidth}px;
                                max-height:${slideHeight}px;
                            }
                        `
            }}
          />
        }
        <div style={slideStyle}>
          <ReactCrop
            onImageLoaded={this.handleImageLoaded(img, url, index)}
            keepSelection
            onComplete={this.onComplete(img, url, index)}
            src={_url}
            crop={resConfig}
          />
        </div>
      </Modal>
    )
  }
}
